import { AppPathList, AppRouteNameList } from 'router';
import { REGULARS } from 'utils';

export function getPathWithId(path: typeof AppPathList[AppRouteNameList], id: string | number) {
	return path.replace(REGULARS.pathId, id?.toString());
}
